var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skill rectangle flex items-center justify-center lg:justify-start mx-auto",class:{
        skill__locked: !_vm.trophy.unlocked,
        medium: _vm.isMedium,
        high: _vm.isHigh, }},[_c('div',{staticClass:"content lg:flex lg:items-center",class:{
        'text-center': _vm.trophy.icon === undefined
    }},[(_vm.trophy.icon !== undefined)?_c('img',{staticClass:"lg:mr-2",attrs:{"src":_vm.trophy.icon.url,"alt":""}}):_vm._e(),_c('p',{domProps:{"innerHTML":_vm._s(_vm.trophy.text.replace(/\n/g, '<br />'))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }